import type { TResellerBranding } from '@/reseller/reseller.types';

export const BRANDING: TResellerBranding = {
  consoleName: 'SDA Console',
  backofficeName: 'SDA Backoffice',
  abbreviation: 'SDA',
};
